module.exports = __webpack_public_path__ + "img/td.0a0e4742.png";